import axios from 'axios';

/**
 * Function that return axios post promise
 * @param {Object} params - Content body in JSON
 * @param {String} url - refresh token endpoint
 * @returns {Promise}
 */
export const postRefreshToken = async(params, url=process.env.REACT_APP_API_AUTH_REFRESH) => {
    const body = {
        refresh_token: params.refreshToken,
    };

    return axios.post(url, body)
}